module.exports = __webpack_public_path__ + "3bc5dae5d5da576f43895f679b602889.pdf";